import { useOrganization } from '../useOrganization';
import { calculateOrganisationColors, FJELL } from './organization-theme-model';

export const PRIMARY_ORGANIZATION_COLOR = 'primary-organization-color';
export const SECONDARY_ORGANIZATION_COLOR = 'secondary-organization-color';
export const TERTIARY_ORGANIZATION_COLOR = 'tertiary-organization-color';
export const WHITE_ORGANIZATION_COLOR = 'white-organization-color';
export const SAND_ORGANIZATION_COLOR = 'sand-organization-color';
export const SAND_SECONDARY_ORGANIZATION_COLOR = 'sand-secondary-organization-color';

export const OrganizationTheme = ({ children, className, theme }) => {
    const organization = useOrganization();

    const themeColor = organization?.themeColor;

    const {
        secondaryColor,
        primaryColor,
        tertiaryColor,
        sandColor,
        primaryTextColor,
        secondaryTextColor,
        tertiaryTextColor,
        sandTextColor,
        hoverColor,
    } = calculateOrganisationColors(themeColor);

    if (theme === SAND_ORGANIZATION_COLOR && themeColor) {
        theme = PRIMARY_ORGANIZATION_COLOR;
    } else if (theme === SAND_SECONDARY_ORGANIZATION_COLOR && themeColor) {
        theme = SECONDARY_ORGANIZATION_COLOR;
    }

    return (
        <>
            <style>
                {`
                ${
                    primaryColor
                        ? `
                    .${PRIMARY_ORGANIZATION_COLOR} {
                        background-color: ${primaryColor};
                        border-color: ${primaryColor};
                        color: ${primaryTextColor};
                        --ffe-color-foreground-default: ${primaryTextColor};
                        --ffe-color-foreground-emphasis: ${primaryTextColor};
                        --ffe-color-foreground-interactive-link: ${primaryTextColor};
                        --rounded-button-important-hover-background-color: ${hoverColor};
                        --rounded-button-important-background-color: ${hoverColor};
                        --rounded-button-primary-hover-background-color: ${hoverColor};
                        --rounded-button-primary-background-color: ${hoverColor};
                        --border-focus-color: ${primaryColor};
                    }
                    .${WHITE_ORGANIZATION_COLOR} {
                        background-color: #FFF;
                        border-color: #262626;
                        color: #262626;
                        --ffe-color-foreground-default: #262626;
                        --ffe-color-foreground-emphasis: #262626;
                        --rounded-button-secondary-hover-background-color: ${primaryColor};
                        --rounded-button-secondary-hover-text-color:${primaryTextColor};
                        --rounded-button-secondary-hover-background-color: ${primaryColor};
                        --rounded-button-primary-hover-background-color: ${primaryColor};
                        --rounded-button-primary-hover-text-color: ${primaryTextColor};
                        --border-focus-color: ${primaryColor};
                    }
                    `
                        : `
                    .${SAND_ORGANIZATION_COLOR} {
                        background-color: ${sandColor};
                        border-color:  ${sandColor};
                        color: ${sandTextColor};
                        --ffe-color-foreground-default: ${sandTextColor};
                        --ffe-color-foreground-emphasis: ${FJELL};
                        --rounded-button-secondary-hover-background-color: ${primaryColor};
                        --rounded-button-secondary-hover-text-color:${primaryTextColor};
                        --border-focus-color: ${primaryColor};
                    }
                    `
                }
                    .${SECONDARY_ORGANIZATION_COLOR} {
                        background-color: ${secondaryColor};
                        border-color: ${secondaryColor};
                        color: ${secondaryTextColor};
                        --ffe-color-foreground-default: ${secondaryTextColor};
                        --ffe-color-foreground-emphasis: ${secondaryTextColor};
                        --ffe-color-foreground-interactive-link: ${secondaryTextColor};
                    }

                    .${TERTIARY_ORGANIZATION_COLOR} {
                        background-color: ${tertiaryColor};
                        border-color: ${tertiaryColor};
                        color: ${tertiaryTextColor};
                        --ffe-color-foreground-default: ${tertiaryTextColor};
                        --ffe-color-foreground-emphasis: ${tertiaryTextColor};
                        --ffe-color-foreground-interactive-link: ${tertiaryTextColor};
                        fill: ${secondaryColor}
                    }

                    .${SAND_SECONDARY_ORGANIZATION_COLOR} {
                        background-color: ${sandColor};
                        border-color:  ${sandColor};
                        color: ${sandTextColor};
                        --ffe-color-foreground-default: ${sandTextColor};
                        --ffe-color-foreground-emphasis: ${FJELL};
                    }
                `}
            </style>
            <div className={[className, theme].join(' ')}>{children}</div>
        </>
    );
};
